import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { getDatabase, ref, set } from 'firebase/database';
import './SignUp.css';
import { Link } from 'react-router-dom';
import { TermsCheckbox } from '../Safety/Safety';
import { termsAcceptanceFields } from '../safety';

function SignUp({ setLoggedIn }) {
  const [name,            setName]            = useState('');
  const [email,           setEmail]           = useState('');
  const [username,        setUsername]        = useState('');
  const [number,          setNumber]          = useState('');
  const [password,        setPassword]        = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [agreed,          setAgreed]          = useState(false);
  const [error,           setError]           = useState('');

  const signUpUser = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) { setError('Passwords do not match.'); return; }
    if (!agreed) { setError('Please agree to the Terms of Use to create an account.'); return; }
    try {
      const auth = getAuth();
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      // Public profile holds only name + username; phone and email go to the
      // private contact entry.
      const db = getDatabase();
      await set(ref(db, 'users/' + cred.user.uid), { username, name, ...termsAcceptanceFields() });
      await set(ref(db, 'contacts/' + cred.user.uid), { email, number });
      // Send verification email — the in-app banner will prompt them to verify
      // without forcing a sign-out and redirect loop.
      sendEmailVerification(cred.user);
    } catch (err) { setError(err.message); }
  };

  return (
    <div className="sign-up-container">
      <div className="sign-up-logo">
        <img src={process.env.PUBLIC_URL + '/mascot-logo.png'} alt="FalconRide" className="sign-up-logo-mark" />
        <h1>Falcon<span>Ride</span></h1>
      </div>

      <form onSubmit={signUpUser} className="sign-up-form">
        <h2>Create Account</h2>
        {error && <p className="error">{error}</p>}
        <input type="text"     placeholder="Full Name"        value={name}            onChange={e => setName(e.target.value)} />
        <input type="email"    placeholder="Email"            value={email}           onChange={e => setEmail(e.target.value)} />
        <input type="text"     placeholder="Username"         value={username}        onChange={e => setUsername(e.target.value)} />
        <input type="tel"      placeholder="Phone Number"     value={number}          onChange={e => setNumber(e.target.value)} />
        <input type="password" placeholder="Password"         value={password}        onChange={e => setPassword(e.target.value)} />
        <input type="password" placeholder="Confirm Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
        <TermsCheckbox checked={agreed} onChange={setAgreed} />
        <button type="submit">Create Account</button>
      </form>

      <div className="sign-up-footer">
        Already have an account? <Link to="/">Log In</Link>
      </div>
    </div>
  );
}

export default SignUp;
